var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_25128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9599 8.23474C9.48442 7.9506 8.875 8.29405 8.875 8.85085V15.5478C8.875 16.1075 9.48538 16.4461 9.9599 16.1649L15.5748 12.8212C16.0417 12.5428 16.0407 11.8673 15.5758 11.588L9.9599 8.23474ZM10.3101 14.2859V10.1147L13.8068 12.2031L10.3101 14.2859Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4934 3.85519C15.0419 3.1941 8.82329 3.1941 4.36983 3.85519C2.58845 4.11924 1.18496 5.51794 0.878819 7.33376C0.308623 10.7042 0.308623 13.7092 0.878819 17.0787C1.18496 18.8955 2.58845 20.2933 4.36983 20.5573C6.60086 20.8883 9.27198 21.0539 11.9421 21.0539C14.6075 21.0539 17.2719 20.8893 19.4944 20.5583C21.2738 20.2942 22.6764 18.8965 22.9844 17.0797C23.5546 13.7092 23.5546 10.7033 22.9844 7.33281C22.6783 5.51794 21.2748 4.11924 19.4934 3.85519ZM21.5695 16.8405C21.3657 18.0421 20.4472 18.9663 19.2829 19.1385C14.9605 19.7805 8.91418 19.7805 4.58031 19.1376C3.41504 18.9644 2.49565 18.0412 2.29283 16.8396C1.74368 13.5925 1.74368 10.8209 2.29283 7.57198C2.4966 6.37036 3.41504 5.4481 4.58126 5.27398C6.74533 4.95348 9.33895 4.79276 11.9307 4.79276C14.5243 4.79276 17.1179 4.95348 19.282 5.27398C20.4472 5.44714 21.3666 6.37036 21.5695 7.57198C22.1186 10.8209 22.1186 13.5925 21.5695 16.8405Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_25128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.9609,
    height: 22.9609,
    fill: "white",
    transform: "translate(0.451172 0.71875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.5381e0f6da3249483f6b32687f9c5872.svg";
export { ForwardRef as ReactComponent };